export const removeWmsLayer = (map, layer1name, layer2name) => {
  if (map?.current?.getSource('linksLayers')) {
    map?.current?.removeLayer('linksLayers');
    map?.current.removeSource('linksLayers');
  }
  if (map?.current?.getLayer('linksLayers-dashed')) {
    map.current.removeLayer('linksLayers-dashed');
    map.current.removeSource('linksLayers');
  }
};
